(ns frontend.view.modals.curtains.delete-option-curtain.view
  (:require
   [common.localization :as loc]
   [common.schema.field-spec :as field-spec]
   [common.schema.registry :as registry]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.modals.curtains.delete-option-curtain.events :as events]
   [ui.components.alert.view :as alert]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.modal.view :as modal]
   [ui.util :as uu]))

(defonce modal-key :curtain/delete-option)

(defn processing
  [data-state]
  [:div
   {:class (uu/cm "p-8 relative hidden left-0 right-0 bottom-0 top-0" (when (:processing? @data-state) "flex justify-center items-center"))}
   [:div
    {:class "flex flex-col gap-3"}
    [:i.fal.fa-spinner.fa-pulse.fa-4x]
    [:span (loc/tr :processing)]]])

(defn view
  [{:keys [shown? topmost? close-modal! props state]}]
  (let [{:keys [header-text named-value on-completed! remove-class-name!]}
        props
        header-text (or header-text (loc/tr :delete-option))
        named-value-attribute (:named-value/attribute named-value)
        named-value-id (:db/id named-value)
        value (:named-value/value named-value)
        tenant-schema @session/tenant-schema
        {:field/keys [mandatory] :as fs}
        (registry/get-field-schema tenant-schema named-value-attribute)
        mandatory-field? (or (field-spec/system-required-field? fs)
                             (= :mandatory/always mandatory))
        prevent-clear? (or mandatory-field?
                           (field-spec/not-clearable-after-set-field? fs))
        value-in-use?
        (fu/value-in-use? session/entities-list named-value-attribute named-value-id)
        prevent-delete? (and prevent-clear?
                             value-in-use?)
        {:keys [confirm-delete? processing? error]} @state
        button-disabled? (or (not confirm-delete?)
                             prevent-delete?)]
    [modal/view
     {:visible?      (and shown? topmost?)
      :hide!         close-modal!
      :backdrop      "static"
      :close-button? true}
     header-text
     [:<>
      (if processing?
        [processing state]
        [:<>
         [:div
          {:class "mb-3"}
          [alert/danger
           {}
           [:div
            [:p (loc/tr :delete-option-modal-info)]]]]
         (when (and value-in-use?
                    (not prevent-delete?))
           [alert/warning
            {}
            [:span
             (loc/tr :delete-option-modal-info-value-in-use [value])]])

         [:div
          {:class "mt-3"}
          (when error
            [:div
             [alert/danger
              {:on-close (fn [_]
                           (swap! state dissoc :error))}
              error]])

          [:label
           {:class "inline-flex items-center gap-3 cursor-pointer"}
           [checkbox/view
            {:value     (boolean confirm-delete?)
             :disabled? false
             :on-change (fn []
                          (swap! state update :confirm-delete? not))}]
           [:span (loc/tr :delete-option-modal-confirm)]]]])]

     (when-not processing?
       [:<>
        [modal/left-cancel-only
         (fn [_]
           (close-modal!)
           (when remove-class-name!
             (remove-class-name!)))
         nil]
        [modal/right-single-button
         nil
         button-disabled?
         (fn [_]
           (events/delete! named-value state close-modal! on-completed!))
         (loc/tr :apply)
         nil]])]))
